import { useCallback, useEffect, useState } from "react";
import apiClient from "@/services/apiClient";

/** @typedef {import("@/APIVO/ResponceVO/Student/IStudentCourseProgress").IStudentCourseProgress} IStudentCourseProgress */
/** @typedef {import("@/APIVO/ResponceVO/Student/IStudentCourseStepProgressHistory").IStudentCourseStepProgressHistory} IStudentCourseStepProgressHistory */

/** @returns {Promise<IStudentCourseStepProgressHistory[]>} */
export async function getCourseProgressHistory(studentBookingId) {
  const response = await apiClient.get("/CourseProgress/History", {
    params: { pStudentBookingId: studentBookingId },
  });
  return Array.isArray(response.data) ? response.data : [];
}

export async function validateCourseProgressStepAccess(studentBookingId, courseStepTypeNo) {
  const response = await apiClient.post("/CourseProgress/ValidateStepAccess", {
    studentBookingId: Number(studentBookingId),
    courseStepTypeNo: Number(courseStepTypeNo),
  });
  return response.data;
}

export function useStudentCourseProgress(studentBookingId, { admin = false } = {}) {
  /** @type {[IStudentCourseProgress | null, import("react").Dispatch<import("react").SetStateAction<IStudentCourseProgress | null>>]} */
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadProgress = useCallback(async () => {
      if (!studentBookingId) {
        setLoading(false);
        setError("Course not found.");
        return;
      }

      try {
        setLoading(true);
        setError("");
        const response = await apiClient.get(admin ? "/CourseProgress/AdminProgress" : "/CourseProgress/Progress", {
          params: { pStudentBookingId: studentBookingId },
        });
        setProgress(response.data);
      } catch (requestError) {
        setProgress(null);
        setError(requestError.response?.data?.message || "Unable to load course progress.");
      } finally {
        setLoading(false);
      }
  }, [studentBookingId, admin]);

  useEffect(() => {
    loadProgress();
  }, [loadProgress]);

  return { progress, setProgress, loading, error, reload: loadProgress };
}
